import React from 'react';
import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useCurrencyFormatter } from '../../../../../../hooks/useCurrencyFormatter';
import { ExpenseByIdQuery } from '../../../../__generated__/graphql';

type CarMileageDistanceDisplayProps = {
  kmDistance: number | null;
  distanceSyncInProgress: boolean;
  isUpdatingExpense: boolean;
  isUpdatingExpenseItem: boolean;
  expenseData?: ExpenseByIdQuery;
};

export const CarMileageDistanceDisplay: React.FC<
  React.PropsWithChildren<CarMileageDistanceDisplayProps>
> = ({
  kmDistance,
  distanceSyncInProgress,
  isUpdatingExpense,
  isUpdatingExpenseItem,
  expenseData,
}) => {
  const { t } = useTranslation();
  const formatCurrency = useCurrencyFormatter();

  return (
    <Col md={12}>
      <div className="d-flex justify-content-between gap-5 mt-3 ms-2 me-2 mb-2">
        <div>
          <div className="mb-2 fw-bold">
            {t('expenses.carMileageForm.distance')}
          </div>
          <div className="fs-2 fw-bold text-primary">
            {distanceSyncInProgress ? (
              <div
                className="spinner-border spinner-border-sm text-primary"
                role="status">
                <span className="visually-hidden">
                  {t('expenses.createEditModal.updating')}...
                </span>
              </div>
            ) : kmDistance !== null ? (
              `${t('expenses.carMileageForm.kmDistance', {
                distance: kmDistance.toFixed(2),
              })}`
            ) : (
              `${t('expenses.carMileageForm.kmDistance', { distance: 0 })}`
            )}
          </div>
        </div>
        <div>
          <div className="mb-2 fw-bold">
            {t('expenses.fields.finalAmountLabel')}
          </div>
          <div
            className={`text-end fs-2 fw-bold ${
              isUpdatingExpense || isUpdatingExpenseItem
                ? 'text-primary'
                : 'text-success'
            }`}>
            {distanceSyncInProgress ? (
              <div
                className="spinner-border spinner-border-sm text-primary"
                role="status">
                <span className="visually-hidden">
                  {t('expenses.createEditModal.updating')}
                </span>
              </div>
            ) : expenseData?.expense?.flair__Final_Amount__c !== undefined &&
              expenseData?.expense?.CurrencyIsoCode ? (
              formatCurrency({
                value: expenseData.expense.flair__Final_Amount__c,
                currency: expenseData.expense.CurrencyIsoCode,
              })
            ) : (
              '?'
            )}
          </div>
        </div>
      </div>
    </Col>
  );
};
